module.exports = __webpack_public_path__ + "img/8.526ce9f2.png";